
import { defineComponent } from 'vue'
import UI_Loader from '@/components/UI/Loader/Loader.vue'
import UI_Modal from '@/components/UI/Modal/Modal.vue'
import jsQR from 'jsqr'
import { errors } from '@/modules/errors'
import { QRdecodeData } from '@/modules/qr'

const __default__ = defineComponent({
  name: 'PageView_Pairing',
  components: {
    UI_Loader,
    UI_Modal
  },
  data: function () {
    return {
      mobile: this.$store.state.browserInfo?.mobile, // desktop debug - insert "true || " before this.$store
      browsername: this.$store.state.browserInfo?.name, // desktop debug - insert "true || " before this.$store
      svgSrc: 'data:image/svg+xml,' + escape(this.$store.state.qrcodeData),
      scrollPos: 0,
      isScrolling: false,
      QRvideo: null as HTMLVideoElement | null,
      QRcanvas: null as HTMLCanvasElement | null, // document.createElement('canvas')
      QRcontext: null as CanvasRenderingContext2D | null,
      enabled: false,
      isLoading: true,
      isScanning: true,
      pairingLink: this.$store.state.qrcodeLink,
      showPairingURL: false,
      showUBL: false,
      coyLinktext: 'Copy Link'
    }
  },
  methods: {
    toggleModal: function (state: boolean) {
      this.coyLinktext = 'Copy Link'
      this.showPairingURL = state
    },
    toggleBModal: function (state: boolean) {
      this.showUBL = state
    },
    copyLink: function (state: boolean) {
      navigator.clipboard.writeText(this.pairingLink).then(() => {
        this.coyLinktext = 'Copied!'
        setTimeout(() => {
          this.coyLinktext = 'Copy Link'
        }, 1500)
      }, (err) => {
        this.coyLinktext = 'Couldn\'t copy link!'
        console.log(err)
      })
    },
    onScroll: function (e: any) {
      const scroll = (e.srcElement.scrollLeft / (e.srcElement.scrollWidth / 2))
      this.isScrolling = true
      this.scrollPos = scroll
      if (scroll === 1 || scroll === 0) {
        this.isScrolling = false
      }
    },
    scrolltoQRDisplay: function (e: any) {
      e.srcElement.scrollTo({
        top: 0,
        left: (e.srcElement.scrollWidth / 2),
        behavior: 'smooth'
      })
    },
    scrolltoQRScan: function (e: any) {
      e.srcElement.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    },
    startScanning: function () {
      this.enabled = true
      this.QRvideo = document.querySelector('.vm-video') as HTMLVideoElement
      this.QRcanvas = document.querySelector('.vm-canvas') as HTMLCanvasElement
      this.QRcontext = this.QRcanvas.getContext('2d')
      navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' } }).then((stream) => {
        console.log(stream)
        const width = stream.getVideoTracks()[0].getSettings().width as number
        const height = stream.getVideoTracks()[0].getSettings().height as number
        console.log(width, height)
        this.QRvideo!.srcObject = stream
        this.QRvideo!.setAttribute('playsinline', 'true')
        this.QRvideo!.play()
        const proc = (func: any) => {
          this.QRcanvas!.width = width
          this.QRcanvas!.height = height
          this.QRcontext!.drawImage(this.QRvideo!, 0, 0, width, height)
          const imageData = this.QRcontext!.getImageData(0, 0, width, height)
          const code = jsQR(imageData.data, imageData.width, imageData.height, {
            inversionAttempts: 'dontInvert'
          })
          if (code) {
            if (this.isScanning === true) {
              this.isScanning = false
              let hasSucceded = false
              const success = (data: Record<string, unknown>) => {
                if (hasSucceded === false) {
                  hasSucceded = true
                  this.isLoading = true
                  this.isScanning = false
                  console.log(code)
                  this.pauseStream(stream)
                  this.$store.dispatch('connectToClientSide', data)
                }
              }
              const faliure = (err: number) => {
                if (hasSucceded === false) {
                  console.log(err + ' - ' + errors[err])
                  this.isLoading = false
                  this.isScanning = true
                }
              }
              QRdecodeData(code.data, success, faliure)
            }
          }
          if (this.isScrolling === false && this.enabled === true) {
            window.requestAnimationFrame(() => func(func))
          }
        }
        window.requestAnimationFrame(() => proc(proc))
      })
    },
    pauseStream: function (stream: MediaStream) {
      this.enabled = false
      const tracks = stream.getTracks()
      tracks.forEach((track) => {
        track.stop()
      })
    }
  },
  mounted: function () {
    if (this.mobile === true && this.browsername === 'safari') {
      this.isLoading = false
      this.showUBL = true
    } else {
      QRdecodeData(window.location.toString(), (data: Record<string, unknown>) => {
        window.location.hash = ''
        this.$store.dispatch('connectToClientSide', data)
      }, () => {
        if (this.mobile === true) {
          this.startScanning()
        }
        this.isLoading = false
      })
    }
  }
})

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "64831c7c": (_ctx.scrollPos)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__